import { theme as themeBase, ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  components: {
    Button: {
      paddingInlineLG: 36,
      controlHeightLG: 44,
      colorBgContainerDisabled: '#373737',
      colorTextDisabled: '#A3A3A3',
      defaultBg: '#171717',
      defaultBorderColor: '#171717',
      defaultColor: '#FAFAFA',
      colorText: '#A3A3A3',
    },
    Input: {
      paddingBlockSM: 9,
      paddingInlineSM: 14,
      borderRadiusSM: 8,
      colorBgContainer: '#171717',
      colorBorder: '#262626',
      colorText: '#FAFAFA',
    },
    Select: {
      controlHeight: 44,
      controlPaddingHorizontal: 14,
      colorBgContainer: '#171717',
      colorBorder: '#262626',
      colorText: '#FAFAFA',
    },
    DatePicker: {
      controlHeight: 44,
      controlPaddingHorizontal: 14,
      colorBgContainer: '#171717',
      colorBorder: '#262626',
      colorText: '#FAFAFA',
    },
    Progress: {
      defaultColor: '#8362D0',
    },
    Card: {
      colorBgContainer: '#171717',
      colorBorderSecondary: '#262626',
    },
    Tooltip: {
      colorBgSpotlight: '#171717',
      borderRadius: 8,
      controlHeight: 52,
      paddingSM: 8,
      fontSize: 12,
      lineHeight: 1.5,
    },
    Modal: {
      contentBg: '#0A0A0A',
      headerBg: '#0A0A0A',
      borderRadiusLG: 12,
      titleFontSize: 24,
      titleLineHeight: 1.33,
      titleColor: '#FAFAFA',
      colorText: '#A3A3A3',
    },
    Layout: {
      siderBg: '#171717',
      headerBg: '#0A0A0A',
      bodyBg: '#0A0A0A',
      headerPadding: 16,
      headerHeight: 68,
    },
    Collapse: {
      headerBg: 'transparent',
      contentBg: 'transparent',
      colorBorder: 'transparent',
      headerPadding: '2px 2px !important',
      contentPadding: '8px 0 !important',
      colorTextHeading: '#8A8A8A',
    },
    Menu: {
      itemColor: '#FAFAFA',
      itemMarginInline: 0,
      itemMarginBlock: 0,
      itemPaddingInline: '0px 2px',
    },
    FloatButton: {
      controlHeightLG: 50,
    },
    Segmented: {
      trackBg: '#0A0A0A',
      itemColor: '#FAFAFA',
      itemSelectedBg: '#171717',
      itemSelectedColor: '#FAFAFA',
      controlPaddingHorizontal: 8,
      fontSizeLG: 16,
    },
    Notification: {
      fontSize: 12,
      fontSizeLG: 16,
      width: 320,
      colorText: '#8A8A8A',
    },
    Dropdown: {
      colorText: '#FAFAFA',
    },
  },
  token: {
    colorPrimary: '#8362D0',
    colorTextBase: '#A3A3A3',
    colorTextHeading: '#FAFAFA',
    colorBgContainer: '#0A0A0A',
    borderRadiusLG: 8,
    colorLink: '#8362D0',
    fontSize: 16,
    fontSizeHeading1: 30,
    fontSizeHeading2: 24,
    fontSizeHeading5: 14,
    fontWeightStrong: 500,
    fontFamily: 'SF Pro Display',
  },
  algorithm: themeBase.darkAlgorithm,
};

export const lightTheme: ThemeConfig = {
  components: {
    Button: {
      paddingInlineLG: 36,
      controlHeightLG: 44,
      colorBgContainerDisabled: '#E5E5E5',
      colorTextDisabled: '#A3A3A3',
      colorText: '#0A0A0A',
    },
    Input: {
      paddingBlockSM: 9,
      paddingInlineSM: 14,
      borderRadiusSM: 8,
      colorBgContainer: '#FAFAFA',
      colorBorder: '#E5E5E5',
      colorText: '#0A0A0A',
    },
    Select: {
      controlHeight: 44,
      controlPaddingHorizontal: 14,
      colorBgContainer: '#FAFAFA',
      colorBorder: '#E5E5E5',
      colorText: '#0A0A0A',
    },
    DatePicker: {
      controlHeight: 44,
      controlPaddingHorizontal: 14,
      colorBgContainer: '#FAFAFA',
      colorBorder: '#E5E5E5',
      colorText: '#0A0A0A',
    },
    Progress: {
      defaultColor: '#8362D0',
    },
    Card: {
      colorBgContainer: '#FAFAFA',
      colorBorderSecondary: '#E5E5E5',
    },
    Tooltip: {
      colorBgSpotlight: '#171717',
      borderRadius: 8,
      controlHeight: 52,
      paddingSM: 8,
      fontSize: 12,
      lineHeight: 1.5,
    },
    Modal: {
      contentBg: '#F5F5F5',
      headerBg: '#F5F5F5',
      borderRadiusLG: 12,
      titleFontSize: 24,
      titleLineHeight: 1.33,
      titleColor: '#0A0A0A',
      colorText: '#A3A3A3',
    },
    Layout: {
      siderBg: '#F5F5F5',
      headerBg: '#FAFAFA',
      bodyBg: '#FAFAFA',
      headerPadding: 16,
      headerHeight: 68,
    },
    Collapse: {
      headerBg: 'transparent',
      contentBg: 'transparent',
      colorBorder: 'transparent',
      headerPadding: '2px 2px !important',
      contentPadding: '8px 0 !important',
      colorTextHeading: '#8A8A8A',
    },
    Menu: {
      itemColor: '#0A0A0A',
      itemMarginInline: 0,
      itemMarginBlock: 0,
      itemPaddingInline: '0px 2px',
    },
    FloatButton: {
      controlHeightLG: 50,
    },
    Segmented: {
      trackBg: '#FAFAFA',
      itemColor: '#8A8A8A',
      itemSelectedBg: '#E5E5E5',
      itemSelectedColor: '#0A0A0A',
      controlPaddingHorizontal: 8,
      fontSizeLG: 16,
    },
    Notification: {
      fontSize: 12,
      fontSizeLG: 16,
      width: 320,
      colorText: '#8A8A8A',
    },
    Dropdown: {
      colorText: '#0A0A0A',
    },
  },
  token: {
    ...theme.token,
    colorPrimary: '#7438FF',
    colorLink: '#7438FF',
    colorTextBase: '#8A8A8A',
    colorTextHeading: '#0A0A0A',
    colorBgContainer: '#FAFAFA',
    colorTextPlaceholder: '#A3A3A3',
  },
  algorithm: themeBase.defaultAlgorithm,
};
